import React from 'react';
import { Path, Svg, type SvgProps } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

export interface FacebookIconProps extends SvgProps {
  size?: number;
  color?: keyof AppColors;
}

const FacebookIcon: React.FC<FacebookIconProps> = ({
  size = 64,
  color = 'iconPrimary',
  ...props
}) => {
  const { theme: colors } = useUnistyles();

  return (
    <Svg width={size} height={size} viewBox="0 0 6 12" fill="none" {...props}>
      <Path
        d="M5.63845 0H3.72062C2.58252 0 1.31663 0.478669 1.31663 2.12839C1.32219 2.70322 1.31663 3.25373 1.31663 3.8733H0V5.96844H1.35737V12H3.85162V5.92864H5.4979L5.64686 3.86742H3.80864C3.80864 3.86742 3.81275 2.9505 3.80864 2.68423C3.80864 2.03229 4.487 2.06963 4.5278 2.06963C4.85061 2.06963 5.47827 2.07057 5.63939 2.06963V0H5.63845Z"
        fill={colors[color]}
      />
    </Svg>
  );
};

FacebookIcon.displayName = 'FacebookIcon';
export { FacebookIcon };
